import { render } from "./HeroPage.vue?vue&type=template&id=2fed819e&scoped=true"
import script from "./HeroPage.vue?vue&type=script&lang=js"
export * from "./HeroPage.vue?vue&type=script&lang=js"

import "./HeroPage.vue?vue&type=style&index=0&id=2fed819e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fed819e"]])

export default __exports__